// ════════════════════════════════════════════════════════════════════════
// useLoginForm.ts — Estado del formulario de login (mismo patrón que useLeadForm)
// ════════════════════════════════════════════════════════════════════════

import { useReducer, useCallback } from 'react';

interface LoginFormState {
  username: string;
  password: string;
}

type LoginFormAction =
  | { type: 'SET_FIELD'; field: keyof LoginFormState; value: string }
  | { type: 'RESET' };

const initialState: LoginFormState = { username: '', password: '' };

function loginFormReducer(state: LoginFormState, action: LoginFormAction): LoginFormState {
  switch (action.type) {
    case 'SET_FIELD':
      return { ...state, [action.field]: action.value };
    case 'RESET':
      return { ...initialState };
    default:
      return state;
  }
}

interface UseLoginFormReturn {
  formState: LoginFormState;
  setField: (field: keyof LoginFormState, value: string) => void;
  reset: () => void;
  isValid: boolean;
}

export function useLoginForm(): UseLoginFormReturn {
  const [formState, dispatch] = useReducer(loginFormReducer, initialState);

  const setField = useCallback((field: keyof LoginFormState, value: string): void => {
    dispatch({ type: 'SET_FIELD', field, value });
  }, []);

  const reset = useCallback((): void => {
    dispatch({ type: 'RESET' });
  }, []);

  const isValid = formState.username.trim().length > 0 && formState.password.trim().length > 0;

  return { formState, setField, reset, isValid };
}
